var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.allowItemNotes
    ? _c("div", [
        _c("div", { staticClass: "cart-instructions-wrapper" }, [
          _c(
            "label",
            {
              staticClass: "cart-instructions-label",
              attrs: { for: "special-instructions" },
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cart-instructions-wrapper" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.specialInstructionsValue,
                expression: "specialInstructionsValue",
              },
            ],
            staticClass: "cart-instructions",
            attrs: {
              id: "special-instructions",
              name: "special-instructions",
              cols: "30",
              rows: "3",
              placeholder: _vm.placeholder,
            },
            domProps: { value: _vm.specialInstructionsValue },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.specialInstructionsValue = $event.target.value
                },
                function ($event) {
                  return _vm.$emit("input", $event.target.value)
                },
              ],
            },
          }),
        ]),
      ])
    : _c("div", [
        _c("div", { staticClass: "cart-instructions-wrapper" }, [
          _c(
            "label",
            {
              staticClass: "cart-instructions-label",
              attrs: { for: "cart-instructions" },
            },
            [_vm._v(_vm._s(_vm.disabledLabel))]
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cart-instructions-wrapper" }, [
      _c("textarea", {
        staticClass: "cart-instructions area-disabled",
        attrs: {
          disabled: "",
          id: "cart-instructions",
          name: "cart-instructions",
          cols: "30",
          rows: "3",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }